module.exports = __webpack_public_path__ + "static/media/9.e4509f61.jpg";